import LtIconCharacterLookup from "@landtechnologies/icons/font/lt-icons.json";

export type LtIconKey = keyof typeof LtIconCharacterLookup;

export function getIconUnicodeCharFromKey(iconKey: LtIconKey) {
  const iconCode = LtIconCharacterLookup[iconKey];
  if (!iconCode) return "";
  return String.fromCharCode(+iconCode);
}
